export const resultDensities = {
  DENSE: 'dense',
  SPARSE: 'sparse',
};

export default {};
